import React, { Component, Fragment } from 'react'
import { CheckCircleFilled } from '@ant-design/icons'
import { Input } from 'hljd'
import styles from './formStyle'

class Phone extends Component {
  constructor(props) {
    super(props)

    this.state = {
      visible: false
    }
  }

  verify = () => {
    const { validateFields } = this.props
    validateFields(['contact_phone'], (errors, values) => {
      if (errors == null) {
        this.setState({ visible: true })
      } else {
        this.setState({ visible: false })
      }
    })
  }

  render() {
    const { value, onChange } = this.props
    const { visible } = this.state

    return (
      <Fragment>
        <Input
          style={{ width: 250 }}
          onBlur={this.verify}
          value={value}
          onChange={value => onChange(value)}
        />
        <CheckCircleFilled
          className={styles.rightIcon}
          style={{ display: visible ? 'inline-block' : 'none' }}
        />
      </Fragment>
    )
  }
}

export default Phone
